import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useQuery } from 'react-query'
import * as actions from './actions'
import * as locationActions from '../../../../locations/actions'

import Icon from '@mdi/react'
import { InputAdornment, makeStyles } from '@material-ui/core'
import { mdiClose, mdiEmailOutline } from '@mdi/js'
import { isEmailString } from 'web/src/utils'
import { enqueueSnackbar } from '../../../actions'

import { Modal } from '..'
import { Button } from '..'
import { Input } from '..'

import { useMap, MapContainer, Marker } from 'react-leaflet'
import { GetMarkerIcon } from '../../../../locations/utils/get-marker-icon'

import L from 'leaflet'
import 'leaflet-easyprint'
import 'leaflet-simple-map-screenshoter'
import 'react-image-lightbox/style.css'
import Loader from 'react-spinners/ClipLoader'
import { isEmpty } from 'lodash'
import { LOCALE_MAP_ADJUSTED, LOCALE_MAP_REVERSED } from '../../../constants'
import { fetchLocation } from '../../../../locations/api/locations-api'
import { TextField, Chip } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { Loading } from '../../common'
import { fetchDevice } from '../../../../devices/api/device-api'

const useStyles = makeStyles(theme => ({
    closeIcon: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center'
    },
    mainText: {
        textAlign: 'center',
        color: '#868686',
        fontFamily: 'Inter',
        fontWeight: '400',
        fontSize: '23.875px',
        marginBottom: '5%'
    },
    modalButton: {
        display: 'flex',
        float: 'right',
        marginTop: '20px'
    },
    mainSection: {
        width: '55%',
        margin: '0 auto'
    },
    input: {
        border: '1px solid black',
        marginBottom: '3%',
        borderRadius: '5px',
        background: '#FFFFFF !important',
        paddingLeft: '25px',
        '& div': {
            background: 'white !important'
        }
    },
    inputSection: {
        display: 'flex'
    },
    textareaInput: {
        minHeight: '220px',
        border: `0.5px solid ${theme.secondary}`,
        borderRadius: theme.borderRadius,
        width: '80%',
        '& div': {
            background: 'white !important'
        }
    },
    textareaSection: {
        display: 'flex',
        backgroundColor: 'white',
        marginTop: '5%'
    },
    label: {
        color: theme.textPrimary,
        alignItems: 'center',
        width: '20%'
    },
    textAreaLabel: {
        color: theme.textPrimary,
        width: '20%'
    },
    inputContainer: {
        display: 'flex',
        width: '80%',
        position: 'relative',
        border: '1px solid black',
        borderRadius: '5px',
        background: '#FFFFFF !important',
        paddingLeft: '25px',
        '& div': {
            background: 'white !important'
        }
    },
    spanIcon: {
        position: 'absolute',
        top: '33%',
        left: '3%',
        margin: '0 auto',
        zIndex: 1
    },
    autocompleteWrapper: {
        position: 'relative',
        width: '80%'
    },
    buttonCancel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    buttonSend: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& span': {
            marginRight: 0
        }
    },
    printMapWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '1000px',
        transform: 'scale(0)',
        pointerEvents: 'none'
    },
    loader: {
        marginTop: '5px',
        marginRight: '10px'
    }
}))

const ReportEmailSender = ({ setIsModalOpen, reportData }) => {
    const dispatch = useDispatch()
    const classes = useStyles()

    const { locale, theme } = useSelector(state => state.main)
    const { floorPlan, floorPlanDevices } = useSelector(
        state => state.locations
    )

    let localization = localStorage.getItem('locale')

    const deviceName = reportData.device_name
    const locationName = reportData.location_name
    const organisationName = reportData.customer_name

    const dateTimeOfCapture = new Date(reportData.created_at).toLocaleString(
        LOCALE_MAP_ADJUSTED[localization]
    )

    const messageTemplate = composeMessageTemplate(
        locale,
        deviceName,
        locationName,
        dateTimeOfCapture,
        organisationName,
        null
    )
    const [emailsAn, setEmailsAn] = useState([])
    const [emailsCc, setEmailsCc] = useState([])
    const [emailMessage, setEmailMessage] = useState(messageTemplate)
    const [flooplanImage, setFloorplanImage] = useState(null)
    const [flooplanImageZoom, setFloorplanImageZoom] = useState(null)
    const [isSendDisabled, setIsSendDisabled] = useState(false)
    const [isWithFloorplan, setIsWithFloorplan] = useState(false)
    const [reportDevice, setReportDevice] = useState()

    const sendMail = (
        an,
        cc,
        message,
        localization,
        reportData,
        image,
        imageZoom
    ) => {
        dispatch(
            actions.sendMailReport({
                emailAn: an.join(','),
                emailCc: cc.join(','),
                emailMessage: message,
                reportData: reportData,
                localization: LOCALE_MAP_REVERSED[localization],
                image: image,
                imageZoom: imageZoom
            })
        )
        setIsModalOpen(false)
    }

    useEffect(() => {
        dispatch(locationActions.floorPlanRequest(reportData.location_id))
        return () => {
            dispatch(locationActions.floorPlanSuccess(null))
        }
    }, [])

    useEffect(() => {
        if (isEmpty(floorPlan) || isEmpty(floorPlanDevices)) {
            setIsSendDisabled(false)
            setIsWithFloorplan(false)
        } else {
            let result = floorPlanDevices.filter(
                device => device.id === reportData.device_id
            )

            if (
                isEmpty(result) ||
                !result[0].coordinates ||
                !result[0].floor_plan_id
            ) {
                setIsWithFloorplan(false)
                setIsSendDisabled(false)
            } else {
                setReportDevice(result[0])
                setIsWithFloorplan(true)
                setIsSendDisabled(true)
            }
        }
    }, [floorPlan, floorPlanDevices])

    const { data: locationData, isLoading: isLoadingLocation } = useQuery(
        ['fetchLocation', reportData.location_id],
        () => fetchLocation(reportData.location_id),
        {
            refetchOnWindowFocus: false,
            onSuccess: data => {
                setEmailsAn(data.contact_email ? [data.contact_email] : [])
            },
            cacheTime: 0,
            onError: () =>
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.commonLoadingError,
                        options: {
                            variant: 'error'
                        }
                    })
                )
        }
    )
    const { data: deviceData, isLoading: isLoadingDevice } = useQuery(
        ['fetchDevice', reportData.device_id],
        () => fetchDevice(reportData.device_id),
        {
            refetchOnWindowFocus: false,
            onSuccess: data => {
                setEmailMessage(
                    composeMessageTemplate(
                        locale,
                        deviceName,
                        locationName,
                        dateTimeOfCapture,
                        organisationName,
                        data?.description
                    )
                )
            },
            cacheTime: 0,
            onError: () => {
                // skip error on purpose
            }
        }
    )

    if (isLoadingLocation || isLoadingDevice) {
        return <Loading />
    }

    return (
        <React.Fragment>
            <Modal
                size="lg"
                open={open}
                style={{ backdropFilter: 'blur(7px)' }}>
                <span className={classes.closeIcon}>
                    <Icon
                        path={mdiClose}
                        size={1}
                        color={theme.shareIconColor}
                        onClick={() => setIsModalOpen(false)}
                    />
                </span>

                <h1 className={classes.mainText}>
                    {locale.reports.sendMessage}
                </h1>

                <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
                    <div className={classes.mainSection}>
                        <div className={classes.inputSection}>
                            <label className={classes.label}>
                                {locale.common.emailTo}:{' '}
                            </label>
                            <div className={classes.autocompleteWrapper}>
                                <Autocomplete
                                    multiple
                                    id="tags-filled"
                                    options={[]}
                                    value={emailsAn}
                                    freeSolo
                                    onChange={(e, value, situation, option) => {
                                        setEmailsAn(value)
                                    }}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                variant="outlined"
                                                label={option}
                                                {...getTagProps({ index })}
                                                key={`${index}-${option}`}
                                            />
                                        ))
                                    }
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder={
                                                !isEmpty(emailsAn)
                                                    ? ''
                                                    : locale.common.email
                                            }
                                            type="email"
                                            onBlur={e => {
                                                const value = e.target.value
                                                if (
                                                    typeof value === 'string' &&
                                                    value.length > 0
                                                ) {
                                                    const newEmailsAn = [
                                                        ...emailsAn,
                                                        e.target.value
                                                    ]
                                                    setEmailsAn(newEmailsAn)
                                                }
                                            }}
                                            /* InputProps={{ 
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Icon
                                                                path={mdiEmailOutline}
                                                                size={1}
                                                                color={theme.quaternary}
                                                            />
                                                        </InputAdornment>
                                                    )
                                                }} */
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div style={{ padding: 10 }}></div>
                        <div className={classes.inputSection}>
                            <label className={classes.label}>
                                {locale.common.emailCc}:{' '}
                            </label>
                            <div className={classes.autocompleteWrapper}>
                                <Autocomplete
                                    multiple
                                    id="tags-filled"
                                    options={[]}
                                    value={emailsCc}
                                    freeSolo
                                    onChange={(e, value, situation, option) => {
                                        setEmailsCc(value)
                                    }}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                variant="outlined"
                                                label={option}
                                                {...getTagProps({ index })}
                                                key={`${index}-${option}`}
                                            />
                                        ))
                                    }
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder={
                                                !isEmpty(emailsCc)
                                                    ? ''
                                                    : locale.common.email
                                            }
                                            type="email"
                                            onBlur={e => {
                                                const value = e.target.value
                                                if (
                                                    typeof value === 'string' &&
                                                    value.length > 0
                                                ) {
                                                    const newEmailsCc = [
                                                        ...emailsCc,
                                                        e.target.value
                                                    ]
                                                    setEmailsCc(newEmailsCc)
                                                }
                                            }}
                                            /* InputProps={{ 
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Icon
                                                            path={mdiEmailOutline}
                                                            size={1}
                                                            color={theme.quaternary}
                                                        />
                                                    </InputAdornment>
                                                )
                                            }} */
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={classes.textareaSection}>
                            <label className={classes.textAreaLabel}>
                                {locale.reports.message}:{' '}
                            </label>
                            <Input
                                multiline={true}
                                className={classes.textareaInput}
                                setValue={setEmailMessage}
                                value={emailMessage}
                            />
                        </div>
                        <div className={classes.modalButton}>
                            {isSendDisabled ? (
                                <div className={classes.loader}>
                                    <Loader />
                                </div>
                            ) : null}
                            <Button
                                reverted
                                className={classes.buttonCancel}
                                style={{ marginRight: '5px' }}
                                onClick={() => setIsModalOpen(false)}>
                                {locale.reports.cancle}
                            </Button>
                            <Button
                                sign
                                className={classes.buttonSend}
                                disabled={isSendDisabled}
                                onClick={sendMail.bind(
                                    this,
                                    emailsAn,
                                    emailsCc,
                                    emailMessage,
                                    localization,
                                    reportData,
                                    flooplanImage,
                                    flooplanImageZoom
                                )}>
                                {locale.reports.send}
                            </Button>
                        </div>
                    </div>
                </div>
                {isWithFloorplan ? (
                    <div className={classes.printMapWrapper}>
                        <div className={classes.textareaSection}>
                            <MapContainer
                                //option to fix safari bug with popups
                                tap={false}
                                style={{ height: '80vh' }}
                                zoom={0}
                                scrollWheelZoom={true}
                                crs={L.CRS.Simple}
                                minZoom={-5}
                                zoomSnap={0.5}
                                zoomDelta={0.5}>
                                <FloorPlanInner
                                    locale={locale}
                                    floorPlan={floorPlan}
                                    device={reportDevice}
                                    setFloorplanImage={setFloorplanImage}
                                    setFloorplanImageZoom={
                                        setFloorplanImageZoom
                                    }
                                    setIsSendDisabled={setIsSendDisabled}
                                />
                            </MapContainer>
                        </div>
                    </div>
                ) : null}
            </Modal>
        </React.Fragment>
    )
}

const dataURItoBlob = dataURI => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
    } else {
        byteString = unescape(dataURI.split(',')[1])
    }
    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to a typed array
    let ia = new Uint8Array(byteString.length)
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
    }

    return new Blob([ia], { type: mimeString })
}

const FloorPlanInner = ({
    floorPlan,
    device,
    locale,
    setFloorplanImage,
    setFloorplanImageZoom,
    setIsSendDisabled
}) => {
    const map = useMap()
    const dispatch = useDispatch()

    let format = 'canvas'
    let takeFloorplanScreenShot
    let takeZoomedFloorplanScreenShot

    const captureFloorplan = () => {
        takeFloorplanScreenShot = L.simpleMapScreenshoter().addTo(map)
        takeFloorplanScreenShot
            .takeScreen(format)
            .then(canvas => {
                const blob = dataURItoBlob(canvas.toDataURL('image/png', 1))
                const file = new File([blob], 'image1', { type: 'image/png' })
                setFloorplanImage(file)

                map.panTo([
                    device.coordinates.lat,
                    device.coordinates.lon || device.coordinates.lng
                ])

                map.once('moveend', function () {
                    map.zoomIn(1.5)
                })

                map.on('zoomend', function () {
                    takeZoomedFloorplanScreenShot =
                        L.simpleMapScreenshoter().addTo(map)
                    takeZoomedFloorplanScreenShot
                        .takeScreen(format)
                        .then(canvas => {
                            const blob = dataURItoBlob(
                                canvas.toDataURL('image/png', 1)
                            )
                            const file = new File([blob], 'image1', {
                                type: 'image/png'
                            })
                            setFloorplanImageZoom(file)
                            setIsSendDisabled(false)
                        })
                        .catch(e => {
                            console.log(e)
                            setIsSendDisabled(false)
                            setFloorplanImageZoom(null)
                            dispatch(
                                enqueueSnackbar({
                                    message: locale.reports.somethingWentWrong,
                                    options: {
                                        variant: 'error'
                                    }
                                })
                            )
                        })
                })
            })
            .catch(e => {
                console.log('2', e)
                setIsSendDisabled(false)
                setFloorplanImage(null)
                dispatch(
                    enqueueSnackbar({
                        message: locale.reports.somethingWentWrong,
                        options: {
                            variant: 'error'
                        }
                    })
                )
            })
    }

    useEffect(() => {
        const dataString = `data:${floorPlan.mime_type};base64,${floorPlan.floor_plan}`
        L.imageOverlay(dataString, [
            [0, 0],
            [floorPlan.height, floorPlan.width]
        ]).addTo(map)
        map.fitBounds([
            [0, 0],
            [floorPlan.height, floorPlan.width]
        ])
        captureFloorplan()
    }, [])

    return <TriggeredMarker key={device.id} device={device} locale={locale} />
}

const TriggeredMarker = ({ device }) => {
    const [position, setPosition] = useState(device.coordinates)
    const markerRef = useRef(null)
    const floorDeviceIcon = GetMarkerIcon('critical')

    return (
        <Marker
            position={position}
            ref={markerRef}
            icon={floorDeviceIcon}></Marker>
    )
}

const composeMessageTemplate = (
    locale,
    deviceName,
    locationName,
    dateTimeOfCapture,
    organisationName,
    deviceDescription
) => {
    const deviceDescriptionSection = deviceDescription
        ? ` - ${deviceDescription}`
        : ''
    return (
        locale.reports.mailMessageBegin +
        '\n\n' +
        locale.reports.mailMessageMainSection +
        deviceName +
        ' - ' +
        locationName +
        locale.reports.on +
        dateTimeOfCapture +
        deviceDescriptionSection +
        ' ' +
        locale.reports.mailMessageMainSection2 +
        '\n\n' +
        locale.reports.mailMessageMainSection3 +
        '\n\n' +
        locale.reports.mailMessageEnd +
        '\n' +
        organisationName
    )
}

export default ReportEmailSender
